export const safeZE = (...args: Parameters<typeof window.zE>): void => {
  if (typeof window.zE === 'function') {
    window.zE(...args);

    return;
  }

  const script = document.getElementById('ze-snippet');

  if (script) {
    script.addEventListener('load', () => window.zE(...args), { once: true });
  }
};
